import { render } from "./dtl_record.vue?vue&type=template&id=4e371f16&scoped=true"
import script from "./dtl_record.vue?vue&type=script&lang=js"
export * from "./dtl_record.vue?vue&type=script&lang=js"

import "./dtl_record.vue?vue&type=style&index=0&id=4e371f16&scoped=true&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e371f16"]])

export default __exports__